<script lang="ts">
    import { route } from './helpers/router';
    import Modals from './shared_components/modals/Modals.svelte';
    // import { Router, Route, Link } from 'svelte-navigator';
    import Services from './pages/services/index.svelte';
    import Service from './pages/service/index.svelte';
    import Thankyou from './pages/thankyou/index.svelte';
    import Form from './pages/form/index.svelte';

    import Router from 'svelte-spa-router';
    import { onMount } from 'svelte';

    // const routes = {
    //     // Exact path
    //     '/': Services,

    //     // Using named parameters, with last being optional
    //     '/details': Service,

    //     // Wildcard parameter
    //     '/form': Form,

    //     '/thankyou': Thankyou,
    // };
</script>

<main>
    <svelte:component this={route()} />
</main>

<!-- <Router {routes} /> -->
<Modals />

<!-- <Router>
    <main>
        <Route path="details" component={Service} />
        <Route path="form" component={Form} />
        <Route path="thankyou" component={Thankyou} />
        <Route path="/" component={Services} />
    </main>

    <Modals />
</Router> -->
